import StarRoundedIcon from '@mui/icons-material/StarRounded';
import type { SxProps } from '@mui/material';

interface Props {
  sx?: SxProps;
}

export function FavoritePresetIcon({ sx }: Props) {
  return (
    <StarRoundedIcon
      sx={{ fontSize: '0.875rem', color: '#F9C12E', flexShrink: 0, ...sx }}
    />
  );
}
